export default (restServer) => ({
    DETAILS: () => restServer("/internal/api/user/details"),
});
